let development = false;

export default {
    development: development,
    api_url: (development) ? 'http://localhost:1339' : ''
}